export { UpdateProductModal } from './UpdateProductModal';
